import React from 'react';
import { useTranslation } from 'react-i18next';

export interface TabItem {
  label?: string | React.ReactNode;
  key: string;
  isActive: boolean;
  count?: number;
  allowed?: boolean;
}

interface TabsContainerProperties {
  containerTabs: TabItem[];
  handleSwitchTab: (key: string) => void;
}

/**
 * Shared component for rendering the tabs container.
 * @param {TabsContainerProperties} properties - The component properties.
 * @returns {React.JSX.Element} The rendered tabs container component.
 */
function TabsContainer(properties: Readonly<TabsContainerProperties>) {
  const { t } = useTranslation('sidePanel');
  const { containerTabs, handleSwitchTab } = properties;

  return (
    <div className="tabs-container">
      {containerTabs.map((tab) => (
        <div
          key={tab.key}
          className={`each-tab ${tab.isActive ? 'active' : ''}`}
          role="presentation"
          onClick={() => handleSwitchTab(tab.key)}>
          {tab.count !== undefined ? (
            <div className="tab-label-container has-badge">
              <span>{tab.label ?? t(tab.key)}</span>
              <span className="tab-badge">{tab.count}</span>
            </div>
          ) : (
            <span>{tab.label ?? t(tab.key)}</span>
          )}
        </div>
      ))}
    </div>
  );
}

TabsContainer.defaultProps = {
  className: '',
};

export default TabsContainer;
